import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: '3px',
    height: 'auto',
  },
}))

const Card = (props) => {
  const classes = useStyles()
  const { className, children, ...remaingProps } = props
  return (
    <Box className={`${classes.root} ${className}`} {...remaingProps}>
      {children}
    </Box>
  )
}

export default Card
